import { MenuItem as MUIMenuItem, styled } from "~/common/mui";
import { FontSize, getFontStyle } from "../materialInput/Fonts";
import { C_DROPDOWN_HOVER, C_ON_SURFACE, C_OUTLINE_VARIANT, C_PRIMARY } from "../icon/Colors";

/*
  @deprecated - use the mui MenuItem instead
*/
export const MenuItem = styled(MUIMenuItem)({
  ...getFontStyle(FontSize.TitleMedium),
  padding: "10px 20px",
  color: `${C_ON_SURFACE} !important`,
  "&:hover": {
    backgroundColor: `${C_DROPDOWN_HOVER} !important`,
  },
  "&.Mui-selected": {
    color: C_PRIMARY,
    backgroundColor: "transparent !important",
  },
});

export const MenuItemNavigation = styled(MUIMenuItem)({
  ...getFontStyle(FontSize.TitleSmall),
  color: C_ON_SURFACE,
  width: 200,
  "&.Mui-selected": {
    color: C_PRIMARY,
    backgroundColor: "transparent !important",
  },
  padding: "8px 12px",
});

interface MenuSpacerProps {
  fullwidth?: boolean;
}
export const MenuSpacer = styled("hr")(({ fullwidth }: MenuSpacerProps) => ({
  margin: fullwidth ? "0" : "0 20px",
  borderTop: `1px solid ${C_OUTLINE_VARIANT}`,
}));
